var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57129 5.15039C4.65592 5.15039 4.73568 5.13411 4.81055 5.10156C4.88542 5.06901 4.95378 5.02018 5.01562 4.95508L8.73145 1.15137C8.84212 1.04069 8.89746 0.908854 8.89746 0.755859C8.89746 0.648438 8.87142 0.550781 8.81934 0.462891C8.77051 0.375 8.70378 0.306641 8.61914 0.257812C8.53451 0.205729 8.43848 0.179688 8.33105 0.179688C8.1748 0.179688 8.03809 0.238281 7.9209 0.355469L4.33691 4.03223H4.81055L1.22168 0.355469C1.10449 0.238281 0.967773 0.179688 0.811523 0.179688C0.704102 0.179688 0.608073 0.205729 0.523438 0.257812C0.438802 0.306641 0.370443 0.375 0.318359 0.462891C0.269531 0.550781 0.245117 0.648438 0.245117 0.755859C0.245117 0.833984 0.258138 0.907227 0.28418 0.975586C0.313477 1.04069 0.355794 1.09928 0.411133 1.15137L4.12695 4.95508C4.26042 5.08529 4.40853 5.15039 4.57129 5.15039Z",
    fill: "#9F9F9F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.8d204b1dc79ca750c8e9beb488bc2c6a.svg";
export { ForwardRef as ReactComponent };